<template>
  <div class="alignfull elhandel-container elhandel-bg">
    <div class="container-lg container-fluid">
      <div class="row justify-content-center align-items-center p-lg-5 py-3">
        <div class="col-12 col-lg-6 col-xl-5" v-if="!loaded">
          <img class="mx-auto d-block" width="100" src="https://cdn.gavleenergi.se/img/spinner.svg" />
        </div>
        <div class="col-12 col-lg-6 col-xl-5" v-if="loaded == true && products.length < 1">Hittar inga produkter på
          adressen, det kan bero på att {{ title }} inte är tillgängligt i elområde {{ elomrade }}.</div>


        <div class="col-12 col-lg-6 col-xl-5" :class="{ 'd-none': !loaded || products.length < 1 }"
          v-if="loaded == true && products.length > 0">
          <div class="">
            <div class="">
              <span class="bg-white p-3 rounded-circle d-inline-block mb-3">
                <i class="fa-regular fa-bolt text-default fa-lg fa-fw" :class="selectedProduct.imageUrl"
                  aria-hidden="true"></i>
              </span>
            </div>
            <h1 v-if="loaded == true && products.length > 0">
              {{ getProductTextById(1) }}
            </h1>
            <div v-if="loaded == true && products.length > 0">
              <p class="lead">{{ getProductTextById(2) }}</p>
            </div>
            <div id="usps" v-if="loaded == true && products.length > 0">
              <ul class="list-unstyled">
                <li v-for="(item, i) in getUSP(selectedProduct.texts)" :key="i" class="">
                  <p class="m-0"><i class="far fa-check fa-fw"></i> {{ item.text }}</p>
                </li>
              </ul>
            </div>

            <div class="mb-1">
              <div class="h2 m-0">
                {{
                  swapDecimalChar(((selectedProduct.totalPriceNoDiscountVat * consumption) / 12 / 100 +
                    selectedProduct.monthlyFee * 1).toFixed(0))
                }}
                kr/mån
              </div>
              <div>{{ swapDecimalChar(selectedProduct.totalPriceNoDiscountVat) }} öre/kWh</div>
            </div>
            <!-- <select v-if="products.length > 1" v-model="selectedProduct">
                  <option v-for="(product, i) in products" :value="product" :key="i" :selected="selectedProduct.productId == selectedProduct.productId">{{ selectedProduct.texts.find((text) => text.typeId == 1).text }}</option>
                </select> -->

            <!-- 
                <div class="d-flex mb-3">
                  <div>
                    <input id="lagenhet" v-model="home" type="radio" value="lagenhet" placeholder="Lägenhet" />

                    <label class="inputLgh" for="lagenhet"> Lägenhet </label>
                  </div>
                  <div>
                    <input id="radhus" v-model="home" type="radio" value="radhus" placeholder="Radhus" />

                    <label class="inputRadhus" for="radhus"> Radhus </label>
                  </div>
                  <div>
                    <input id="villa" v-model="home" type="radio" value="villa" placeholder="Villa" />

                    <label class="inputVilla" for="villa"> Villa </label>
                  </div>
                </div> -->
            <div id="options">
              <div class="my-3">
                Priset är baserad på att du bor i
                <select class="form-select d-inline-block" v-model="home">
                  <option value="lagenhet">lägenhet</option>
                  <option value="radhus">radhus</option>
                  <option value="villa">villa</option>
                </select><br />
                och har en förbrukning på
                <input class="form-control d-inline-block" v-model="consumption" type="number" maxlength="5"
                  aria-describedby="consumption" />
                kWh/år.
              </div>
            </div>

            <ProductSpecs v-if="loaded == true && products.length > 0" :isIndeXelProduct="isIndeXelProduct"
              :getProductTextById="getProductTextById" :swapDecimalChar="swapDecimalChar" :consumption="consumption"
              :selectedProduct="selectedProduct"></ProductSpecs>
          </div>
        </div>

        <div class="col-12 col-lg-6 col-xl-5">
          <div class=" ">
            <div class="bg-default shadow p-xxl-5 p-4 rounded elhandel-box">
              <h4 class="mb-3">
                Teckna <mark>{{ this.formtitle }}</mark>
              </h4>

              <div class="mb-3 d-block" v-if="currentStep == 0">
                <div v-if="loaded == true && products.length > 0">
                  <div>
                    <div class="mt-2">
                      <div class="radio d-flex align-items-center" v-for="(product, i) in filteredProducts" :key="i">
                        <label class="form-check-label" :for="'flexRadioDefault' + i">
                          <input class="form-check-input" type="radio" v-model="selectedProduct" :value="product"
                            name="flexRadioDefault" :id="'flexRadioDefault' + i" />
                          <span></span>
                          {{ product.texts.find((text) => text.typeId == 1).text }}  
                        </label>
                        <span v-if="product.priceSource == 5" class="p-1 ms-1" style="font-size: 10px; background-color: #47525d; font-weight: 600; color: #fff;">
                          <i class="fa-solid fa-circle-info"></i> Blir kvartsprisavtal 1/10 
                          <a href="https://www.gavleenergi.se/2025/04/fran-timpris-till-kvartspris-det-har-behover-du-veta/" target="_blank" style="color: #fff;">Läs mer.</a>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="mt-3" v-if="electricitysources.length > 1">
                    <label class="fw-bold">Välj elens ursprung</label>
                    <p class="mb-2">Läs mer om <a class="ek-link" href="https://www.gavleenergi.se/vara-energikallor/"
                        rel="noopener noreferrer" target="_blank">våra energikällor.</a></p>
                    <div class="radio" v-for="source in electricitysources" :key="source">
                      <label class="form-check-label">
                        <input class="form-check-input" type="radio" name="electricitySource" :value="source"
                          v-model="selectedElectricitySource" @change="filterProducts" />
                        <span></span>
                        {{ source === 1 ? "Förnybar" : "Fossilfri" }}
                      </label>
                    </div>
                  </div>
                  <div>

                  </div>


                </div>
              </div>
              <AddressSearch :currentStep="currentStep" :storedAddress="address" :selectAddress="newAddressHandler" />

              <!-- <lime-form form-id="kLhnvxOCuJD3CNSlsi1P"></lime-form> -->
              <lime-form :form-id="formId"></lime-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!--LÄGG IN UTRÄKNING PÅ JÄMFÖRPRIS DYNAMISKT UTIFRÅN FÖRBRUKNINGEN-->
      <div v-if="loaded == true && products.length > 0" class="col-12">
        <div class="border-top py-4 text-center elhandel-bottom">
          <div class="container">
            <div class="item">
              Jämförpriset är
              {{
                swapDecimalChar(
                  (((selectedProduct.monthlyFee * 12) / comparePriceConsumptionLevel) * 100 +
                    selectedProduct.totalPriceNoDiscountVat * 1).toFixed(2)
                )
              }}
              öre/kWh inkl. moms baserat på {{ comparePriceConsumptionLevel }} kWh/år. Fast månadsavgift {{
                selectedProduct.monthlyFee }} kr/mån är
              inräknat i priset.
            </div>
            <div class="break"></div>
            <!-- break -->
            <div class="item">
              Priset är baserat på senaste månadens genomsnittspris och att du bor i elområde {{ elomrade }}.
              Elnätskostnad tillkommer.
              Uppsägningstid: {{ selectedProduct.noticePeriod }} {{ selectedProduct.noticePeriod == 1 ? "månad" :
                "månader" }}.<br>
              {{ getProductTextById(7) }}

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <componentStyles></componentStyles>
</template>

<script>
import axios from "axios";
import VueCookies from "vue-cookies";
import AddressSearch from "./AddressSearch.vue";
import componentStyles from "../componentStyles.vue";
import ProductSpecs from "./ProductSpecs.vue";
export default {
  props: { productgroup: { type: String }, formtitle: { type: String }, presetproduct: { type: String } },
  components: { componentStyles, ProductSpecs, AddressSearch },
  data() {
    let threeWeeksFromNow = new Date();
    threeWeeksFromNow.setDate(threeWeeksFromNow.getDate() + 21);
    threeWeeksFromNow = threeWeeksFromNow.toISOString().slice(0, 10);
    let address = "";
    if (VueCookies.get("geab_searchAddr-latest")) {
      address = VueCookies.get("geab_searchAddr-latest");
      console.log("adress fanns");
    }

    return {
      products: [],
      noProducts: false,
      elomrade: 3,
      selectedProduct: null,
      consumption: 3000,
      pristyp: 1,
      address,
      comparePrice: 0,
      priceTotal: 0,
      home: "lagenhet",
      profile: 3462,
      //formId: "41ZY70DSnCioHzR57XY4",
      formId: "Av7dGkJLkY0Ovue0KoWv",
      loaded: false,
      threeWeeksFromNow,
      currentStep: 0,
      comparePriceConsumptionLevel: 2000,
      previousDate: threeWeeksFromNow,
      electricitysources: [],
      selectedElectricitySource: 1,
      filteredProducts: [],
      elnat: {
        elomrade: 3,
        natagare: "Gävle Energi AB",
        natomradeNamn: "Gävle",
        natomradeBeteckning: "GVL",
        EdielID: 20400,
        telefon: "026 - 17 85 75",
        epost: "elnatsfullmakter@gavleenergi.se",
      },
    };
  },

  methods: {
    async init() {
      this.formsApi.setFieldValue("startdatum", this.threeWeeksFromNow);
      this.formsApi.setFieldValue("lime_deadlinetime", this.threeWeeksFromNow + "T11:00:00.000+01:00");
      //console.log("init-datum: " + this.threeWeeksFromNow)
      //Om det finns en cookie med besökarens senast sökta adress + elområde så använd det istället.
      if (VueCookies.get("geab_searchArea-latest")) {
        this.elnat = VueCookies.get("geab_searchArea-latest");
      }
      if (VueCookies.get("geab_searchAddr-latest")) {
        console.log("adress fanns när init() kördes, sätter");

        let address = VueCookies.get("geab_searchAddr-latest");
        this.formsApi.setFieldValue("adress", address);
      }

      await this.fetchPrice(this.elnat);
    },

    //Hämta elområde.
    fetchElomrade(streetAddress, city) {
      return axios
        .get(
          `https://simpliform.gavleenergi.se/elomraden/adress/${streetAddress}/ort/${city}?integration_company_id=1`,
          {},
          {
            withCredentials: true,
            headers: {
              "X-CSRF-TOKEN": window.limeForms.csrfToken,
            },
          }
        )
        .then(({ data }) => {
          VueCookies.set("geab_searchAddr-latest", streetAddress + ", " + city);
          VueCookies.set("geab_searchArea-latest", data.data.elnat);
          this.elnat = data.data.elnat;
          return data.data.elnat;
        });
    },

    //Hämta produkter
    async fetchPrice(elnat) {
      this.elomrade = elnat.elomrade;

      this.loaded = false;
      this.products = [];
      this.electricitysources = [];

      let newDate = await this.formsApi.getFieldValue("startdatum");

      let data = {
        ElectrictyArea: elnat.elomrade,
        ProfileId: this.profile,
        StartDate: newDate.length > 3 ? newDate : this.threeWeeksFromNow,
        //CampaignCode: "module-f8a161d2-ba79-4b21-b52d-d94b44ad05e7_part-d5fbf70e-2d85-43bb-9543-86a545f0139a",
        CampaignCode: "",
        ProductGroupCode: this.productgroup,
        Language: "Swedish",
        Consumption: this.consumption,
        Elomrade: elnat,
      };
      let products = await axios.post("//simpliform.gavleenergi.se/shop/products", data, {
        withCredentials: true,
        headers: {
          "X-CSRF-TOKEN": window.limeForms.csrfToken,
        },
      });
      if (products.data.data.products.length < 1) {
        //console.log("PRODUKKTer < 1")
        //console.log(products.data.data.products)
        this.products = [];

        this.formsApi.setFieldValue("product_json", null)
        this.products = [];
      } else {
        this.products = products.data.data.products;

        // Hitta unika energikällor
        this.electricitysources = [...new Set(this.products.map(product => product.electricitysource))];
        console.log(this.electricitysources)
        if (this.selectedElectricitySource) {
          console.log("filtrerar produkter på energikälla")
          this.filteredProducts = this.products.filter(
            product => product.electricitysource === this.selectedElectricitySource
          );
        } else {
          this.filteredProducts = this.products;
        }
        if (this.selectedProduct && this.selectedProduct.productId) {
          console.log(this.selectedProduct.productId)
          console.log(this.products)
          let selectedProduct = products.data.data.products.find(product => product.productId == this.selectedProduct.productId)
          console.log(selectedProduct)
          if (selectedProduct) {
            console.log("ny produkt väljs")
            this.selectedProduct = selectedProduct;
          }
        } else {
          console.log("välj ny produkt")
          this.selectedProduct = this.filteredProducts[0];

        }
        //console.log(products.data.data.products);
        this.formsApi.setFieldValue("transaction_id", products.data.transaction_id);
      }

      this.loaded = true;

    },
    filterProducts() {
      if (this.selectedElectricitySource) {
        console.log("filtrerar produkter på energikälla 2")
        this.filteredProducts = this.products.filter(
          product => product.electricitysource === this.selectedElectricitySource
        );
        console.log("filtrerade produkter:")
        console.log(this.filteredProducts)
      } else {
        this.filteredProducts = this.products;
      }
      console.log("this.selectedProduct")
      console.log(this.selectedProduct)
      if (this.selectedProduct.texts) {
        let currentProductName = this.getProductTextById(1);
        this.selectedProduct = this.filteredProducts.find(product => {
          if (product.texts) {
            const matchFound = product.texts.some(text => {
              //console.log( text.text.trim() == currentProductName.trim() + ` Comparing: typeId=${text.typeId}, text=${text.text} with currentProductName=${currentProductName}`);
              return text.typeId == 1 && text.text == currentProductName;
            });
            //console.log("Match Found:", matchFound);
            return matchFound;
          }
          return false;
          //OM ingen matchande produkt hittades i samlingen med produkter i vald energikälla finns så väljs den första i arrayen
        }) || this.filteredProducts[0]

        console.log(currentProductName)
        console.log("Filtered Products:", this.filteredProducts);
        console.log(this.selectedProduct)
      }


    },

    setFieldValues() {
      this.formsApi.setFieldValue("product_json", JSON.stringify(this.selectedProduct));
      this.formsApi.setFieldValue("product_id", this.selectedProduct.productId);
      this.formsApi.setFieldValue("product_price", this.selectedProduct.totalPriceNoDiscountVat);
      this.formsApi.setFieldValue("product_monthlyfee", this.selectedProduct.monthlyFee);
      this.formsApi.setFieldValue("profil", this.profile);
      this.formsApi.setFieldValue("dinforbrukning", this.consumption);
      this.formsApi.setFieldValue("accommodation", this.home);
      this.setLinkParams();
    },

    swapDecimalChar(value) {
      if (value == null) return "";
      return value.toString().replace(".", ",");
    },

    async newAddressHandler(newAddress) {
      this.formsApi.setFieldValue("adress", newAddress);
      if (newAddress.length > 2) {
        //console.log("ny adress");
        this.loaded = false;
        let fullAddress = this.formsApi.getFieldValue("adress");
        this.address = fullAddress;
        let streetAddress = fullAddress.split(", ")[0];
        let city = fullAddress.split(", ")[1];
        let elnat = await this.fetchElomrade(streetAddress, city);
        await this.fetchPrice(elnat);
      }
    },




    setLinkParams() {
      this.formsApi.setFieldValue(
        "linkParams",
        "?product=" +
        this.selectedProduct.texts.find((text) => text.typeId == 1).text +
        "&address=" +
        this.address +
        "&contractperiod=" +
        this.selectedProduct.contractLength +
        "&noticeperiod=" +
        this.selectedProduct.noticePeriod +
        "&price=" +
        this.selectedProduct.totalPriceNoDiscountVat +
        "&startdate=" +
        this.formsApi.getFieldValue("startdatum") +
        "&enddate=" +
        this.selectedProduct.newContractEndDate +    
        "&date=" +
        new Date().toJSON().slice(0, 10).replace(/-/g, "-")
      );
    },


    startdateHandler() {
      //this.formsApi.setFieldValue("startdatum", newDate);
      //this.formsApi.setFieldValue("lime_deadlinetime", newDate + "T11:00:00.000+01:00");
      this.setLinkParams();
      if (this.selectedProduct.priceSource == 10) {
        //if(newDate.slice(0,4) !== oldDate.slice(0,4) || newDate.slice(5,7) !== oldDate.slice(5,7)) {
        console.log("ny månad eller år, ny hämtning av pris för bundet!!!!");
        this.loaded = false;
        this.fetchPrice(this.elnat);
        //}

      }
    },
    getUSP(texts) {
      return texts.filter((text) => text.typeId == 6);
    },
    // Kontrollerar om det är en IndeXel-produkt
    isIndeXelProduct(product) {
      //console.log('isIndeXelProduct (' + product.priceSource + ')');
      if (product.priceSource == 6 || product.priceSource == 7) {
        //console.log("isIndeXelProduct = true");
        return true;
      }
      //console.log("isIndeXelProduct = false");
      return false;
    },
    getProductTextById(id) {
      //console.log('Letar produkttext med id: ' + id);
      let text = this.selectedProduct.texts.find((t) => t.typeId == id);
      if (text) {
        return text.text;
      }
    },
  },

  watch: {
    home(newValue) {
      newValue == "villa"
        ? ((this.consumption = 20000), (this.profile = 3463))
        : newValue == "radhus"
          ? ((this.consumption = 5000), (this.profile = 3462))
          : ((this.consumption = 3000), (this.profile = 3462));

      this.formsApi.setFieldValue("profil", this.profile);
      this.formsApi.setFieldValue("dinforbrukning", this.consumption);
      this.formsApi.setFieldValue("accommodation", this.home);
    },

    consumption() {
      this.setFieldValues();
      this.consumption < 3500
        ? (this.comparePriceConsumptionLevel = 2000)
        : this.consumption < 12500
          ? (this.comparePriceConsumptionLevel = 5000)
          : (this.comparePriceConsumptionLevel = 20000);
    },

    selectedProduct() {
      this.setFieldValues();
    },

  },
  mounted() {
    this.formsApi = window.limeForms.getApi(this.formId);

    this.formsApi.onReady(() => {
      this.init();
      this.formsApi.onFieldValueChange("startdatum", this.startdateHandler.bind(this.formsApi));
      this.formsApi.onStepChange((from, to) => {
        this.currentStep = to.index;
      });
    });
  },
};
</script>
